import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/products/default1.jpg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-695adbe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-3 col-xxxl-3" }
const _hoisted_3 = { class: "products-sidebar-filter bg-white letter-spacing mb-25" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-0 fw-semibold text-secondary" }, "Filtres")
], -1))
const _hoisted_5 = { class: "sidebar-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-black fw-bold fs-md-15" }, "Catégories", -1))
const _hoisted_7 = { class: "categories-list ps-0 mb-0 list-unstyled" }
const _hoisted_8 = { class: "d-flex align-items-center justify-content-between text-paragraph" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-check mb-0" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-check-input shadow-none",
    type: "checkbox",
    id: "allCategories"
  }),
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label fs-md-15 fw-medium",
    for: "allCategories"
  }, " Toutes les catégories ")
], -1))
const _hoisted_10 = { class: "d-block fw-medium text-muted" }
const _hoisted_11 = { class: "form-check mb-0" }
const _hoisted_12 = ["id", "value"]
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "d-block fw-medium text-muted" }
const _hoisted_15 = { class: "sidebar-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-black fw-bold fs-md-15" }, "Analyse(Tags)", -1))
const _hoisted_17 = { class: "tags-container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input shadow-none d-none",
  type: "checkbox",
  id: "allBrands"
}, null, -1))
const _hoisted_19 = {
  class: "form-check-label badge-checkbox fw-medium",
  for: "allBrands"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge-text" }, "Tous les tags", -1))
const _hoisted_21 = { class: "badge bg-secondary ms-2" }
const _hoisted_22 = ["id", "value"]
const _hoisted_23 = ["for"]
const _hoisted_24 = { class: "badge-text" }
const _hoisted_25 = { class: "badge bg-secondary ms-2" }
const _hoisted_26 = { class: "col-lg-9 col-xxxl-9" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-12 mb-25" }
const _hoisted_29 = { class: "bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-5" }
const _hoisted_30 = { class: "row align-items-center" }
const _hoisted_31 = { class: "col-xl-6 col-lg-6 col-md-6" }
const _hoisted_32 = { class: "col-xl-6 col-lg-6 col-md-6" }
const _hoisted_33 = { class: "card mb-25 border-0 rounded-0 bg-white single-product-box" }
const _hoisted_34 = { class: "card-body p-0 letter-spacing" }
const _hoisted_35 = { class: "image position-relative" }
const _hoisted_36 = ["alt"]
const _hoisted_37 = {
  class: "overlay position-absolute w-100 h-100 d-flex align-items-center justify-content-center",
  style: {"top":"0","left":"0","background":"rgba(0, 0, 0, 0.5)","opacity":"0","transition":"opacity 0.3s"}
}
const _hoisted_38 = { class: "overlay-actions d-flex gap-3" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-heart" }, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "ribbon position-absolute" }
const _hoisted_49 = { class: "ribbon-text" }
const _hoisted_50 = { class: "content p-20" }
const _hoisted_51 = {
  class: "mb-5 fw-semibold fs-16 fs-lg-18",
  style: {"height":"60px"}
}
const _hoisted_52 = {
  href: "#",
  class: "text-decoration-none text-black"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted fw-medium fs-13 mb-0" }, " Auteur / Producteur: ", -1))
const _hoisted_54 = { class: "text-black fw-bold fs-6 mb-0" }
const _hoisted_55 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_56 = { class: "text-muted" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar me-1" }, null, -1))
const _hoisted_58 = ["onClick"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye transition" }, null, -1))
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-shopping-cart-2 transition" }, null, -1))
const _hoisted_62 = {
  key: 0,
  class: "col-12"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center py-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book fs-1 text-muted" }),
  /*#__PURE__*/_createElementVNode("h5", { class: "text-muted mt-3" }, "Aucun document trouvé"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Aucun document ne correspond à vos critères de recherche.")
], -1))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_66 = { class: "modal-content p-15 p-md-40" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fw-bold text-black" }, " Demande de prêt")
], -1))
const _hoisted_68 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_69 = { class: "document-info mb-4 p-3 bg-light rounded" }
const _hoisted_70 = { class: "fw-bold mb-2" }
const _hoisted_71 = { class: "text-muted mb-1" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user me-1" }, null, -1))
const _hoisted_73 = { class: "text-muted mb-1" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-more-1 me-1" }, null, -1))
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Date de début"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_79 = { class: "col-md-6" }
const _hoisted_80 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Date de fin "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_82 = { class: "col-md-12" }
const _hoisted_83 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Motif de la demande "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_85 = ["onUpdate:modelValue"]
const _hoisted_86 = { class: "form-text" }
const _hoisted_87 = { class: "text-muted" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-info",
    role: "alert"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-info me-2" }),
    /*#__PURE__*/_createElementVNode("small", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Informations importantes :"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" • Vous recevrez une notification de confirmation par email"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" • Le document devra être retourné dans les délais impartis ")
    ])
  ])
], -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "float-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
    type: "submit"
  }, " Enregistrer "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger ms-5",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, "Annuler ")
], -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close shadow-none",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_91 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

import { ref, computed, onMounted, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import { hideModal, showModal, success } from "@/utils/utils";
import { Document } from "@/models/Document";
import ApiService from "@/services/ApiService";
import { format_date, suppression, error } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import { useRouter } from 'vue-router';
import { hide } from "@popperjs/core";
import Multiselect from '@vueform/multiselect/src/Multiselect';
// Reactive state

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsGrid',
  setup(__props) {

const documents = ref<Array<Document>>([]);
const document = ref<Document>();
const categories = ref<Array<any>>([]); // Assuming categories are of type any, adjust as necessary
const tags = ref<Array<any>>([]); // Assuming tags are of type any, adjust as necessary
const showAllTags = ref(false); // État pour contrôler l'affichage de tous les tags
const showAllCategories = ref(false); // État pour contrôler l'affichage de toutes les catégories
const baseUrl = ref(ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0]);

// Pagination
const searchTerm = ref('');
const page = ref(1);
const totalPages = ref(0);
const limit = ref(10);
const totalElements = ref(0);
const router = useRouter();
const auteurOptions = ref<{ value: any; label: any }[]>([]);
const genreOptions = ref([]);
const auteurSelected = ref(null);
const genreSelected = ref(null);
// Filtres sélectionnés pour catégories et tags
const selectedCategoriesIds = ref<Array<number>>([]);
const selectedTagsIds = ref<Array<number>>([]);
function truncateText(text: string, maxLength: number): string {
  if (!text) return ''
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
}

// Loan request modal
const selectedDocument = ref<Document | null>(null);

// Today's date for date validation
const today = computed(() => {
  const date = new Date();
  return date.toISOString().split('T')[0];
});

// Computed pour gérer l'affichage des tags
const displayedTags = computed(() => {
  if (showAllTags.value) {
    return tags.value;
  }
  return tags.value.slice(0, 15);
});

// Computed pour gérer l'affichage des catégories
const displayedCategories = computed(() => {
  if (showAllCategories.value) {
    return categories.value;
  }
  return categories.value.slice(0, 15);
});

const hasMoreTags = computed(() => {
  return tags.value.length > 15;
});

const hasMoreCategories = computed(() => {
  return categories.value.length > 15;
});

// Computed pour calculer le nombre total de documents pour tous les tags
const totalTagsDocuments = computed(() => {
  return tags.value.reduce((total, tag) => total + (tag.nombreDocuments || 0), 0);
});

// Computed pour calculer le nombre total de documents pour toutes les catégories
const totalCategoriesDocuments = computed(() => {
  return categories.value.reduce((total, category) => total + (category.nombreDocuments || 0), 0);
});

const demandePretModalRef = ref<null | HTMLElement>(null);
// Validation schema for loan request form
const loanSchema = yup.object({
  dateDebut: yup
    .string()
    .required('La date de début est obligatoire')
    .test('is-today-or-future', 'La date de début ne peut pas être antérieure à aujourd\'hui', function (value) {
      if (!value) return false;
      const startDate = new Date(value);
      const todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);
      return startDate >= todayDate;
    }),
  dateFin: yup
    .string()
    .required('La date de fin est obligatoire')
    .test('is-after-start', 'La date de fin doit être postérieure à la date de début', function (value) {
      const { dateDebut } = this.parent;
      if (!value || !dateDebut) return false;
      const startDate = new Date(dateDebut);
      const endDate = new Date(value);
      return endDate > startDate;
    })
    .test('max-30-days', 'La durée maximale d\'un prêt est de 30 jours', function (value) {
      const { dateDebut } = this.parent;
      if (!value || !dateDebut) return false;
      const startDate = new Date(dateDebut);
      const endDate = new Date(value);
      const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 30;
    }),
  motif: yup
    .string()
    .required('Le motif est obligatoire')
    .min(10, 'Le motif doit contenir au moins 10 caractères')
    .max(500, 'Le motif ne peut pas dépasser 500 caractères')
});

// Helper functions
const calculateLoanDuration = (startDate: string, endDate: string): number => {
  if (!startDate || !endDate) return 0;
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = Math.abs(end.getTime() - start.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

const formatDate = (dateString: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR');
};

const rechercher = () => {
  getAllDocuments(page.value, limit.value, searchTerm.value, auteurSelected.value, selectedCategoriesIds.value, selectedTagsIds.value, genreSelected.value);
};

// Fonction pour basculer l'affichage de tous les tags
const toggleTagsDisplay = () => {
  showAllTags.value = !showAllTags.value;
};

// Fonction pour basculer l'affichage de toutes les catégories
const toggleCategoriesDisplay = () => {
  showAllCategories.value = !showAllCategories.value;
};

// Fonction pour gérer la pagination
const handlePaginate = (data) => {
  page.value = data.page_;
  limit.value = data.limit_;
  getAllDocuments(page.value, limit.value, searchTerm.value, auteurSelected.value, selectedCategoriesIds.value, selectedTagsIds.value, genreSelected.value);
};


const getAllDocuments = (page = 1, limi = 10, searchTerm = '', auteurSelected, categorieSelected, tagSelected, genreSelected) => {
  return ApiService.get(`/recherche/documents?page=${page}&limit=${limi}&mot=${searchTerm}&auteur=${auteurSelected || ''}&categories=${categorieSelected || ''}&tags=${tagSelected || ''}&genre=${genreSelected || ''}&`)
    .then(({ data }) => {
      console.log('valeurs', data);
      documents.value = data.data.data;
      totalPages.value = data.data.totalPages;
      limit.value = data.data.limit;
      totalElements.value = data.data.totalElements;
      return data.data;
    })
    .catch(({ response }) => {
      error(response.data.message)
    });
};

const getAllCategories = (page = 1, limi = 10, searchTerm = '') => {
  return ApiService.get(`/categories/with-count`)
    .then(({ data }) => {
      console.log('valeurs', data);
      categories.value = data.data;
      return data.data;
    })
    .catch(({ response }) => {
      error(response.data.message)
    });
};

const getAllTags = (page = 1, limi = 10, searchTerm = '') => {
  return ApiService.get(`/tags/with-count`)
    .then(({ data }) => {
      console.log('valeurs', data);
      tags.value = data.data;
      return data.data;
    })
    .catch(({ response }) => {
      error(response.data.message)
    });
};

const moddifier = (EditDocument) => {
  document.value = EditDocument;
};

const openPdfViewer = (document: Document) => {
  console.log('Document sélectionné:', baseUrl.value, document);
  let pdfUrl = `${baseUrl.value}uploads/2025080113391339130buLZ33wKT.pdf`;

  if (document.nomFichier) {
    pdfUrl = `${baseUrl.value}uploads/${document.nomFichier}`;
  }


  console.log('URL PDF utilisée:', pdfUrl);

  // Enregistrer l'historique de lecture
  const historiqueData = {
    document: document.id,
    types: 'LECTURE',
    user: JwtService.getUser()
  };

  ApiService.post('/historiques', historiqueData)
    .then(response => {
      console.log('Historique de lecture enregistré:', response.data);
    })
    .catch(error => {
      console.log('Erreur lors de l\'enregistrement de l\'historique de lecture:', error);
    });

  router.push({
    name: 'pdf-viewer',
    params: { id: document.id ?? 1 },
    query: { pdfUrl: pdfUrl }
  });
};

const downloadDocument = (document: Document) => {
  if (!document.estTelechargeable) {
    error("Ce document n'est pas téléchargeable");
    return;
  }

  console.log('Téléchargement du document:', document);

  // Enregistrer l'historique de téléchargement
  const historiqueData = {
    document: document.id,
    types: 'TELECHARGEMENT',
    user: JwtService.getUser()
  };

  ApiService.post('/historiques', historiqueData)
    .then(response => {
      console.log('Historique de téléchargement enregistré:', response.data);
    })
    .catch(error => {
      console.log('Erreur lors de l\'enregistrement de l\'historique de téléchargement:', error);
    });

  if (document.nomFichier) {
    const downloadUrl = `${baseUrl.value}uploads/${document.nomFichier}`;
    // Ouvrir le document dans un nouvel onglet
    window.open(downloadUrl, '_blank');
  }
};

const viewDocument = (document: Document) => {
  if (!document.estPublique) {
    error("Ce document n'est pas consultable");
    return;
  }

  // L'historique sera enregistré dans openPdfViewer
  openPdfViewer(document);
};

const toggleFavorite = (document: Document) => {
  console.log('Toggle favorite pour:', document);
  // Implement favorite toggle logic here
};

const openLoanModal = async (doc: Document) => {
  // Récupérer les informations du document sélectionné
  selectedDocument.value = doc;
  showModal(demandePretModalRef.value);
};

const submitLoanRequest = (values: any) => {
  console.log('Demande de prêt soumise:', values);
  console.log('Document sélectionné:', selectedDocument.value);

  // Here you would typically send the loan request to your backend
  const loanData = {
    document: selectedDocument.value?.id,
    documentTitre: selectedDocument.value?.titre,
    dateDebut: values.dateDebut,
    dateFin: values.dateFin,
    motif: values.motif,
    user: JwtService.getUser()
  };

  ApiService.post('/emprunts', loanData)
    .then(response => {
      console.log('Réponse de la demande de prêt:', response.data);
      success(response.data.message);
      // Close the modal
      hideModal(demandePretModalRef.value)
      // Reset the form or perform any other necessary actions
      selectedDocument.value = null;
    })
    .catch(error => {
      console.log('Erreur lors de la demande de prêt:', error);
      // error('Une erreur est survenue lors de la soumission de votre demande de prêt.');
    });

  // TODO: Call your loan request API
  // console.log('Données du prêt à envoyer:', loanData);
  // Show success message
  // alert('Votre demande de prêt a été soumise avec succès!');
};
const fetchSepcificEntity = async (optionName: any, url: string, param: string[]) => {
  try {
    const response = await ApiService.get(url);
    const data = response.data.data.data;
    optionName.value = data.map((item: any) => ({
      value: param[0] ? item[param[0]] : item.id,
      label: param[1] ? item[param[1]] : item.nom,
    }));
  } catch (error) {
    console.error("Erreur récupération données:", error);
  }
};
// Lifecycle
onMounted(async () => {
  console.log('Composant ProductsGrid monté');
  baseUrl.value = ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0];
  await getAllDocuments(page.value, limit.value, searchTerm.value, auteurSelected.value, selectedCategoriesIds.value, selectedTagsIds.value, genreSelected.value);
  await getAllCategories();
  await fetchSepcificEntity(auteurOptions, '/all/auteurs', ['id', 'nom']);
  await fetchSepcificEntity(genreOptions, '/all/genres', ['id', 'nom']);
  await getAllTags();
});

// Watchers pour actualiser la liste des documents à chaque changement de filtre
watch([selectedCategoriesIds, selectedTagsIds, auteurSelected, genreSelected], () => {
  getAllDocuments(page.value, limit.value, searchTerm.value, auteurSelected.value, selectedCategoriesIds.value, selectedTagsIds.value, genreSelected.value);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(totalCategoriesDocuments.value), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedCategories.value, (category) => {
              return (_openBlock(), _createElementBlock("li", {
                key: category.id,
                class: "d-flex align-items-center justify-content-between text-paragraph"
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input shadow-none",
                    type: "checkbox",
                    id: `category_${category.id}`,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCategoriesIds).value = $event)),
                    value: category.id
                  }, null, 8, _hoisted_12), [
                    [_vModelCheckbox, selectedCategoriesIds.value]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label fs-md-15 fw-medium",
                    for: `category_${category.id}`
                  }, _toDisplayString(category.nom), 9, _hoisted_13)
                ]),
                _createElementVNode("span", _hoisted_14, _toDisplayString(category.nombreDocuments), 1)
              ]))
            }), 128))
          ]),
          (hasMoreCategories.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: toggleCategoriesDisplay,
                class: "see-more-btn mt-15 bg-transparent p-0 border-0 position-relative text-uppercase text-primary fw-medium fs-13"
              }, _toDisplayString(showAllCategories.value ? 'Voir moins' : 'Voir plus'), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, [
              _hoisted_18,
              _createElementVNode("label", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, _toDisplayString(totalTagsDocuments.value), 1)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedTags.value, (tag) => {
              return (_openBlock(), _createElementBlock("div", {
                key: tag.id
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input shadow-none d-none",
                  type: "checkbox",
                  id: `tag_${tag.id}`,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTagsIds).value = $event)),
                  value: tag.id
                }, null, 8, _hoisted_22), [
                  [_vModelCheckbox, selectedTagsIds.value]
                ]),
                _createElementVNode("label", {
                  class: "form-check-label badge-checkbox fw-medium",
                  for: `tag_${tag.id}`
                }, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(tag.nom), 1),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(tag.nombreDocuments), 1)
                ], 8, _hoisted_23)
              ]))
            }), 128))
          ]),
          (hasMoreTags.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: toggleTagsDisplay,
                class: "see-more-btn mt-15 bg-transparent p-0 border-0 position-relative text-uppercase text-primary fw-medium fs-13"
              }, _toDisplayString(showAllTags.value ? 'Voir moins' : 'Voir plus'), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_unref(Multiselect), {
                  appendToBody: true,
                  modelValue: auteurSelected.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((auteurSelected).value = $event)),
                  options: auteurOptions.value,
                  placeholder: "Sélectionner l'auteur",
                  searchable: true,
                  label: "label",
                  "track-by": "label",
                  class: "modern-multiselect",
                  onChange: _cache[3] || (_cache[3] = value => auteurSelected.value = value)
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_unref(Multiselect), {
                  appendToBody: true,
                  modelValue: genreSelected.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((genreSelected).value = $event)),
                  options: genreOptions.value,
                  searchable: true,
                  placeholder: "Sélectionner le genre",
                  label: "label",
                  "track-by": "label",
                  class: "modern-multiselect",
                  onChange: _cache[5] || (_cache[5] = value => genreSelected.value = value)
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents.value, (document) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-sm-4 col-lg-4 col-xxxl-3",
            key: document.id
          }, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_router_link, {
                    to: "/product-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: document?.titre || 'Document'
                      }, null, 8, _hoisted_36)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      (document?.estPublique && document?.estTelechargeable)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-light rounded-circle p-2",
                            type: "button",
                            title: "Télécharger",
                            onClick: ($event: any) => (downloadDocument(document))
                          }, _hoisted_41, 8, _hoisted_39))
                        : _createCommentVNode("", true),
                      (document?.estPublique)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-light rounded-circle p-2",
                            type: "button",
                            title: "Visionner",
                            onClick: ($event: any) => (openPdfViewer(document))
                          }, _hoisted_44, 8, _hoisted_42))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "btn btn-light rounded-circle p-2",
                        type: "button",
                        title: "Ajouter aux favoris",
                        onClick: ($event: any) => (toggleFavorite(document))
                      }, _hoisted_47, 8, _hoisted_45)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("span", _hoisted_49, _toDisplayString(document.categorie?.nom || 'Catégorie'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("h4", _hoisted_51, [
                    _createElementVNode("a", _hoisted_52, _toDisplayString(truncateText(document?.titre, 35) || 'Titre non disponible'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_53,
                    _createElementVNode("p", _hoisted_54, _toDisplayString(document?.auteur?.nom || 'Auteur non renseigné') + " " + _toDisplayString(document?.auteur?.prenoms || ''), 1)
                  ]),
                  (document.anneePublication)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("small", _hoisted_56, [
                          _hoisted_57,
                          _createTextVNode(" Publié en " + _toDisplayString(document.anneePublication), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (document?.estPublique)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative",
                        onClick: ($event: any) => (openPdfViewer(document))
                      }, [
                        _createTextVNode(" Lire le document "),
                        _hoisted_59
                      ], 8, _hoisted_58))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative",
                        onClick: ($event: any) => (openLoanModal(document))
                      }, [
                        _createTextVNode(" Demander un prêt "),
                        _hoisted_61
                      ], 8, _hoisted_60))
                ])
              ])
            ])
          ]))
        }), 128)),
        (documents.value?.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "modal fade createNewModal",
        id: "DemandePretModal",
        tabindex: "-1",
        ref_key: "demandePretModalRef",
        ref: demandePretModalRef,
        "aria-hidden": "true"
      }, [
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("h6", _hoisted_70, _toDisplayString(selectedDocument.value?.titre), 1),
                _createElementVNode("p", _hoisted_71, [
                  _hoisted_72,
                  _createTextVNode(" Auteur: " + _toDisplayString(selectedDocument.value?.auteur?.nom || 'Auteur non renseigné') + " " + _toDisplayString(selectedDocument.value?.auteur?.prenoms || ''), 1)
                ]),
                _createElementVNode("p", _hoisted_73, [
                  _hoisted_74,
                  _createTextVNode(" Catégorie: " + _toDisplayString(selectedDocument.value?.categorie?.description || 'Non spécifiée'), 1)
                ])
              ]),
              _createVNode(_unref(Form), {
                ref: "elementForm",
                onSubmit: submitLoanRequest,
                "validation-schema": _unref(loanSchema)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createVNode(_unref(Field), {
                          name: "dateDebut",
                          type: "date",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer la date de début",
                          min: today.value
                        }, null, 8, ["min"]),
                        _createVNode(_unref(ErrorMessage), {
                          name: "dateDebut",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _createVNode(_unref(Field), {
                          name: "dateFin",
                          type: "date",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer la date de fin"
                        }),
                        _createVNode(_unref(ErrorMessage), {
                          name: "dateFin",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _hoisted_84,
                        _createVNode(_unref(Field), { name: "motif" }, {
                          default: _withCtx(({ field }) => [
                            _withDirectives(_createElementVNode("textarea", _mergeProps({
                              class: "form-control",
                              id: "motif",
                              rows: "3",
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, { placeholder: "Décrivez le motif de votre demande de prêt (minimum 10 caractères)..." }), null, 16, _hoisted_85), [
                              [_vModelText, field.value]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(ErrorMessage), {
                          name: "motif",
                          class: "text-danger"
                        }),
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("small", _hoisted_87, [
                            _createTextVNode(" Caractères saisis: "),
                            _createVNode(_unref(Field), { name: "motif" }, {
                              default: _withCtx(({ field }) => [
                                _createTextVNode(_toDisplayString(field.value ? field.value.length
                            : 0), 1)
                              ]),
                              _: 1
                            }),
                            _createTextVNode("/500 ")
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_88
                  ]),
                  _hoisted_89
                ]),
                _: 1
              }, 8, ["validation-schema"])
            ]),
            _hoisted_90
          ])
        ])
      ], 512),
      _createElementVNode("div", _hoisted_91, [
        _createVNode(PaginationComponent, {
          page: page.value,
          totalPages: totalPages.value,
          totalElements: totalElements.value,
          limit: limit.value,
          onPaginate: handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit"])
      ])
    ])
  ]))
}
}

})